import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { I18N, TRANSPORT_METHODS } from '../../../../constants';

const TransportMethodDropdown = ({
    transportMethod,
    rowNumber,
    handleChange,
    disabled,
    isEmaSmaManifest,
    manifestHasTimelines,
}) => (
    <FormControl
        componentClass="select"
        value={transportMethod}
        onChange={e => handleChange(e.target.value, rowNumber)}
        disabled={disabled}
    >
        <option value="">Select Transport Method</option>
        <option value={TRANSPORT_METHODS.INSERT_MANIFEST}>
            {I18N.TRANSPORT_METHODS.INSERT_MANIFEST}
        </option>
        <option value={TRANSPORT_METHODS.SPECIAL}>{I18N.TRANSPORT_METHODS.SPECIAL}</option>
        {!isEmaSmaManifest &&
            manifestHasTimelines && (
                <option value={TRANSPORT_METHODS.PLANNED_LOGISTICS}>
                    {I18N.TRANSPORT_METHODS.PLANNED_LOGISTICS}
                </option>
            )}
    </FormControl>
);

TransportMethodDropdown.propTypes = {
    transportMethod: PropTypes.string,
    rowNumber: PropTypes.number,
    handleChange: PropTypes.func,
    disabled: PropTypes.bool,
};
TransportMethodDropdown.defaultProps = {
    transportMethod: '',
};

export default TransportMethodDropdown;
